var map = {
	"./amex.svg": "adaa",
	"./discover.svg": "f19d",
	"./jcb.svg": "9546",
	"./maestro.svg": "9d4c",
	"./mastercard.svg": "b3f6",
	"./unionpay.svg": "041b",
	"./visa.svg": "ec10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6c9";